import {
  type OrientationType,
  type Resolution,
  type Templates,
} from "@package/ui-gql/index-data-access";

export type ScreenDimension = {
  height: number;
  width: number;
};

export const SCREEN_DIMENSIONS_BY_RESOLUTION_ORIENTATION: {
  [key in Resolution]: { [key in OrientationType]: ScreenDimension };
} = {
  FHD: {
    landscape: {
      height: 1080,
      width: 1920,
    },
    portrait: {
      height: 1920,
      width: 1080,
    },
  },
  UHD: {
    landscape: {
      height: 2160,
      width: 3840,
    },
    portrait: {
      height: 3840,
      width: 2160,
    },
  },
};

export const SCREENS_DIV_ID = "screens-container-div";

export const COLS_BY_TEMPLATE: { [key in Templates]: number } = {
  Custom: 1,
  FiveByOne: 5,
  FiveByThree: 5,
  OneByFive: 1,
  OneByOne: 1,
  OneByThree: 1,
  ThreeByFive: 3,
  ThreeByOne: 3,
  TwoByTwo: 2,
  ZeroByZero: 1,
};

export const ROWS_BY_TEMPLATE: { [key in Templates]: number } = {
  Custom: 1,
  FiveByOne: 1,
  FiveByThree: 3,
  OneByFive: 5,
  OneByOne: 1,
  OneByThree: 3,
  ThreeByFive: 5,
  ThreeByOne: 1,
  TwoByTwo: 2,
  ZeroByZero: 1,
};
